import addClasses from './addClasses';
import removeClasses from './removeClasses';
export default {
  addClasses: addClasses,
  removeClasses: removeClasses
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/esm/components/core/classes/index.js
// module id = null
// module chunks = 